import {EntityModel} from "@fedeltapointofsale/data-client";
import {PurchaseOrderData} from "./purchase-order.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class PurchaseOrderEntityModel extends EntityModel<PurchaseOrderData> {
    constructor(injector: Injector) {
     super(injector, PurchaseOrderData)   ;
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
